import React from 'react';
import PropTypes from 'prop-types';

import FormModal from 'components/form_modal';
import ManagedFormGroup from 'components/form/managed_input/form_group';
import { buildCategoryObject } from './helpers';

import { post, put } from 'helpers/api';

export class DeductionCategoryModal extends React.Component {
  static propTypes = {
    deductionCategoriesPath: PropTypes.string.isRequired,
    deductionCategory: PropTypes.object,
    enableHouseDeductions: PropTypes.bool,
    enableTieredDeductions: PropTypes.bool,
    show: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired
  }

  state = {}

  clearForm = () => {
    if (this.props.deductionCategory) {
      this.setState(this.props.deductionCategory);
    } else {
      this.setState({ 
        houseCategory: false,
        name: null,
        paymentCategory: false,
        voucherCategory: false,
        tier: 1
      });
    }
  }

  handleChange = (changes) => {
    this.setState(changes);
  }

  handleSuccess = () => {
    this.props.onSave(buildCategoryObject(this.state));
  }

  handleSubmit = () => {
    return post(this.props.deductionCategoriesPath, buildCategoryObject(this.state));
  }

  handleEditSubmit = () => {
    return put(this.props.deductionCategoriesPath, { 
      ...buildCategoryObject(this.state),
      oldName: this.props.deductionCategory.name
    });
   
  }

  render() {
    const { voucherCategory, paymentCategory, houseCategory, name, tier } = this.state;
    const values = { voucherCategory, paymentCategory };
    const options = [
      { name: 'voucherCategory', label: 'Pre-Split' }, 
      { name: 'paymentCategory', label: 'Individual' }
    ];

    if (this.props.enableHouseDeductions) {
      values.houseCategory = houseCategory;
      options.push({ name: 'houseCategory', label: 'House' });
    }

    return (
      <FormModal
        header={`${this.props.deductionCategory ? 'Edit' : 'Add' } Category`}
        show={this.props.show}
        onCancel={this.props.onCancel}
        onShow={this.clearForm}
        onSubmit={this.props.deductionCategory ? this.handleEditSubmit : this.handleSubmit}
        onSuccess={this.handleSuccess}
      >
        <div className="form form-horizontal">
          <ManagedFormGroup
            label="Category"
            name="name"
            value={name}
            onChange={this.handleChange}
          />
          <ManagedFormGroup
            checkboxClassName="pl-4"
            inputClassName="d-flex justify-content-start"
            label="Deduction Types"
            name="categories"
            options={options}
            showFullLabelBorder
            type="checkboxGroup"
            value={values}
            onValueChange={this.handleChange}
          />
          {this.props.enableTieredDeductions && voucherCategory && (
            <ManagedFormGroup
              min="1"
              name="tier"
              type="number"
              value={tier}
              onChange={this.handleChange}
            />
          )}
        </div>
      </FormModal>
    );
  }
}

export default DeductionCategoryModal;
